import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/[locale]/news/blogs/[slug]/MainContent.tsx")